<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
          Registration - {{ShortRegCode}}<br><br>
          FullRegCode - {{FullRegCode}}<br><br>
          Device {{DeviceState}}
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
var RegServer = 'https://us-central1-vwatch-vindico.cloudfunctions.net/checkRegistered?regcode='

export default {
  data: () => ({
    counter: 0,
    interval: 1,
    FullRegCode: null,
    ShortRegCode: null,
    DeviceState: null
  }),
  asyncComputed: {
    FullRegCode () {
      return new Promise((resolve, reject) => {
        new this.$fingerprint().get(function (result, components) {
          resolve(result.toUpperCase())
        })
      })
    },
    CheckRegCode () {
      console.log('Running Check Reg Code')
      return new Promise((resolve, reject) => {
        this.$axios.get(RegServer + this.FullRegCode).then(response => resolve(response.data.state))
      })
    }
  },
  methods: {
    CheckState () {
      if (this.CheckRegCode === 'registered') {
        console.log('Checking - Registered')
        clearInterval(this.interval)
        // window.location.replace(this.CheckRegCode.data.redirecturl)
      } else {
        console.log('Checking - ' + this.CheckRegCode)
      }
      this.DeviceState = '' // this.CheckRegCode
    }
  },
  mounted () {
    this.interval = setInterval(function () {
      this.CheckState()
    }.bind(this), 5000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue